//--------- NPM
import 'bootstrap/dist/css/bootstrap.css';
import 'magnific-popup/dist/magnific-popup.css';
import 'jquery-ui/themes/base/all.css';

import './styles/Site.css';
import './styles/css/global.css';
import './styles/css/slider.min.css';
import './styles/css/grantcalculator.css';
//import './styles/css/pi.settings.css';

import $ from 'jquery';

import './cookieJavaScript';
import Slider from 'bootstrap-slider';
import './grant';

document.addEventListener('DOMContentLoaded', function () {    
    if (document.getElementById("ex14") != undefined) {
        var slider = new Slider("#ex14", {
            ticks: [0, 1, 2, 3, 4],
            ticks_positions: [0, 25, 50, 75, 100],
            ticks_labels: ['', '', '', '', ''],
            ticks_snap_bounds: 1
        }).on('change', getValue);
    }
});

function importAll(r) {
    return r.keys().map(r);
}
importAll(require.context('../Scripts/styles/img', false, /\.svg$/));